import CTable from "./table";
export * from "./type";
export default CTable;
